import type { SupportedCurrency } from '@features/currency/currency.types';

export type PublicService = {
  id: string;
  serviceName: string;
  basePrice: string;
  blocks: { type: string; duration: number }[];
  publicName?: string | null;
  publicDescription?: string | null;
};

export type PublicProfileData = {
  userId: string;
  name: string;
  email: string;
  avatarUrl: string | null;
  address: string | null;
  bio: string | null;
  phone: string | null;
  preferredCurrency: SupportedCurrency;
  allowPublicReservations: boolean;
  services: PublicService[];
};

export const getServiceDurationMinutes = (blocks: unknown): number => {
  const parsed: { duration: number }[] =
    typeof blocks === 'string' ? JSON.parse(blocks) : Array.isArray(blocks) ? blocks : [];
  return parsed.reduce((sum, b) => sum + (b?.duration ?? 0), 0);
};
